import React from 'react';
import { Hyperlink } from '../../../components/atoms/Hyperlink';
import { DateFormat } from '../../../_lib/components/DateFormat';
import { Image } from '../../../components/molecules/Image';
import { StateIndicator } from '../../../_lib/components/StateIndicator';
import { TooltipPlacement } from '../../../components/atoms/Tooltip';
import { RESPONSIVE_TYPE } from '../../../components/molecules/Image/Responsive';
import { ISonURL } from '../../../types/IUrl';
import { TitleImage } from '../../../types/api/ImageType';
import { PagePackStates } from '../../../types/api/PagePackState';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { StateIndicatorModifier } from '../../../_lib/components/StateIndicator/StateIndicator';

export type BlogPostListItem = {
  author: string;
  contentDate: string;
  link: ISonURL;
  isFirstItem?: boolean;
  teaserText: string;
  titleImage: TitleImage;
  packState: PagePackStates;
};

export function BlogPostListItem({
  author,
  link,
  contentDate,
  teaserText,
  titleImage,
  isFirstItem,
  packState,
}: BlogPostListItem) {
  const { t } = useSonTranslation('glossary');

  return (
    <li className="blog-post-list__item">
      <Image
        image={{ ...titleImage, alt: link.name, copyright: undefined }}
        linkUrl={link.url}
        hideAdjacentImageLink
        customAltText={link.name}
        responsiveType={isFirstItem ? RESPONSIVE_TYPE.teaserBlogTop : RESPONSIVE_TYPE.teaserBlog}
        lazyLoading
      />
      <article className="blog-post-list__content">
        {(author || contentDate) && (
          <div className="blog-post-list__metainfo font-regular-14-19">
            {author && (
              <>
                <dfn className="invisible">{t('author')}</dfn>{' '}
                <address className="blog-post-list__author">{author}</address>{' '}
              </>
            )}
            {author && contentDate && '-'} {contentDate && <DateFormat date={contentDate} />}
          </div>
        )}
        <h3>
          {packState === 'onlyDraftVersion' ? (
            <StateIndicator status="red" modifier={StateIndicatorModifier.INLINE_BLOCK} />
          ) : null}
          <Hyperlink
            className="blog-post-list__link font-bold-20-34"
            to={link.url}
            title={packState === 'onlyDraftVersion' ? t('draft') : undefined}
            tooltipPlacement={TooltipPlacement.BOTTOM}
          >
            {link.name}
          </Hyperlink>
        </h3>
        <p className="font-regular-16-24">{teaserText}</p>
      </article>
    </li>
  );
}
